import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const Canvas = styled.canvas`
	touch-action: none;
`;

export const Root = styled.div`
	${({ theme }) => css`
		position: relative;
		height: 100%;
		width: 100%;
		background: ${theme.colors.backgrounds[2].background};

		canvas {
			height: 100%;
			width: 100%;
			outline: none;
			touch-action: none;
		}
	`}
`;
